/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
var _a;
var isWeb = typeof window !== 'undefined' && 'onload' in window;
var isMiniDingTalk = typeof dd !== 'undefined' && !!dd && typeof dd.showtoast === 'function';
var isMiniAli = typeof my !== 'undefined' &&
    !!my &&
    (typeof my.showToast === 'function' || typeof my.navigateTo === 'function');
var isMiniTt = typeof tt !== 'undefined' && !!tt && typeof tt.showtoast === 'function';
var isMiniWx = !isMiniTt &&
    typeof wx !== 'undefined' &&
    !!wx &&
    (typeof wx.login !== 'undefined' || typeof wx.miniProgram !== 'undefined');
var isMini = isMiniAli || isMiniWx || isMiniTt;
var isWeex = typeof WXEnvironment !== 'undefined' &&
    !!WXEnvironment &&
    WXEnvironment.platform !== 'Web';
var isQuickApp = typeof global !== 'undefined' &&
    !!global &&
    typeof global.callNative !== 'function' &&
    !isWeex;
var aliUA = '';
try {
    aliUA = navigator.userAgent || navigator.swuserAgent || '';
}
catch (error) {
    aliUA = '';
}
var isMiniweb = (isWeb && aliUA.indexOf('Triver') > -1) || aliUA.indexOf('miniProgram') > -1;
var aliAppMatches = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\)/.exec(aliUA || '') || [];
var client = (_a = aliAppMatches[1]) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase();
var isWindvane = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\).* .*(WindVane)(?:\/((?:\d+\.)+\d+))?.*/.test(aliUA || '');
var isNebula = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\)/.test(aliUA || '') &&
    /.*(Nebula)(?:\/((?:\d+\.)+\d+))?.*/.test(aliUA || '');
var isFliggy = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\) .*(AliTrip)(?:\/((?:\d+\.)+\d+))?.*/.test(aliUA || '');
var isDingTalk = /.+AliApp\((DingTalk)\/((?:\d+\.)+\d+)?.*/.test(aliUA || '');
var isMiniAp = isMiniAli && 'ap' === client;
var isMiniTb = isMiniAli && 'tb' === client;
var isMiniTm = isMiniAli && 'tm' === client;
var isMiniFm = isMiniAli && 'fm' === client;
var isMiniLx = isMiniAli && 'lx' === client;
var isWebTm = isWeb && client === 'tm';
var isWebAliyun = isWeb && client === 'aliyun';
var isWebCn = isWeb && client === 'cn';
var isWebFm = isWeb && client === 'fm';
var isWebRetail = isWeb && client === 'retail';
var isWebXionganapp = isWeb && client === 'xionganapp';
var isWebAfw = isWeb && client === 'afw';
var isWebAp = isWeb && client === 'ap';
var isWebKb = isWeb && client === 'kb';
var isWebRetailtrader = isWeb && client === 'retailtrader';
var isWebXm = isWeb && client === 'xm';
var isWebAk = isWeb && client === 'ak';
var isWebAt = isWeb && client === 'at';
var isWebLt = isWeb && client === 'lt';
var isWebNj = isWeb && client === 'nj';
var isWebTb = isWeb && client === 'tb';
var isWebElmc = isWeb && client === 'elmc';
var isWebIhome = isWeb && client === 'ihome';
var isWebTphome = isWeb && client === 'tphome';
var isWebAliwork = isWeb && client === 'aliwork';
var isWebBk = isWeb && client === 'bk';
var isWebEt = isWeb && client === 'et';
var isWebLx = isWeb && client === 'lx';
var isWebQn = isWeb && client === 'qn';
var isWebYouku = isWeb && client === 'youku';
var isWebWdkhema = isWeb && client === 'wdkhema';
var isWebCunpartner = isWeb && /cunpartner/i.test(aliUA);
var isWebDingTalk = isWeb && client === 'dingtalk';
var isWebAh = isWeb && client === 'ah';
var isWebAlipm = isWeb && client === 'alipm';
var isDingTalkPC = /\s+DingTalk\(/i.test(aliUA);
var isWebDingTalkPC = isDingTalkPC;
var appName = client;
function getUA() {
    return (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) || (navigator === null || navigator === void 0 ? void 0 : navigator.swuserAgent) || '';
}
function isDingTalkMiniApp() {
    return (typeof dd !== 'undefined' && !!dd && typeof dd.showtoast === 'function');
}
function isAliMiniApp() {
    return (typeof my !== 'undefined' &&
        !!my &&
        (typeof my.showToast === 'function' || typeof my.navigateTo === 'function'));
}
function isByteDanceMicroApp() {
    return (typeof tt !== 'undefined' && !!tt && typeof tt.showtoast === 'function');
}
function isWeChatMiniProgram() {
    return (!isByteDanceMicroApp &&
        typeof wx !== 'undefined' &&
        !!wx &&
        (typeof wx.login !== 'undefined' || typeof wx.miniProgram !== 'undefined'));
}
function getAliAppName() {
    var _a;
    var aliUA = getUA();
    var aliAppMatches = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\)/.exec(aliUA || '') || [];
    var app = (_a = aliAppMatches[1]) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase();
    return app || '';
}
function isTm() {
    var app = getAliAppName();
    return app === 'tm';
}
function isTb() {
    var app = getAliAppName();
    return app === 'tb';
}
function isAp() {
    var app = getAliAppName();
    return app === 'ap';
}
function isCn() {
    var app = getAliAppName();
    return app === 'cn';
}
function isAliYun() {
    var app = getAliAppName();
    return app === 'aliyun';
}
function isFm() {
    var app = getAliAppName();
    return app === 'fm';
}
function isRetail() {
    var app = getAliAppName();
    return app === 'retail';
}
function isRetailtrader() {
    var app = getAliAppName();
    return app === 'retailtrader';
}
function isXiongan() {
    var app = getAliAppName();
    return app === 'xiongan';
}
function isAwf() {
    var app = getAliAppName();
    return app === 'afw';
}
function isKb() {
    var app = getAliAppName();
    return app === 'kb';
}
function isAk() {
    var app = getAliAppName();
    return app === 'ak';
}
function isLt() {
    var app = getAliAppName();
    return app === 'lt';
}
function isNj() {
    var app = getAliAppName();
    return app === 'nj';
}
function isElmc() {
    var app = getAliAppName();
    return app === 'elmc';
}
function isIhome() {
    var app = getAliAppName();
    return app === 'ihome';
}
function isTphome() {
    var app = getAliAppName();
    return app === 'tphome';
}
function isAliwork() {
    var app = getAliAppName();
    return app === 'aliwork';
}
function isEt() {
    var app = getAliAppName();
    return app === 'et';
}
function isBk() {
    var app = getAliAppName();
    return app === 'bk';
}
function isLx() {
    var app = getAliAppName();
    return app === 'lx';
}
function isQn() {
    var app = getAliAppName();
    return app === 'qn';
}
function isCunpartner() {
    var app = getAliAppName();
    return app === 'cunpartner';
}
function isDingtalk() {
    var app = getAliAppName();
    return app === 'dingtalk';
}
function isWdkhema() {
    var app = getAliAppName();
    return app === 'wdkhema';
}
function isAh() {
    var app = getAliAppName();
    return app === 'ah';
}
function is1688() {
    var app = getAliAppName();
    return app === '1688';
}
function isMro() {
    var app = getAliAppName();
    return app === 'mro';
}
function isMicrosupply() {
    var app = getAliAppName();
    return app === 'microsupply';
}
var isAndroid = aliUA.indexOf('Android') > -1 || aliUA.indexOf('Adr') > -1;
var isIOS = !!aliUA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
function isIphoneXSeries() {
    var deviceHeight = screen.height * window.devicePixelRatio;
    if (['2340', '2436', '2688', '1792', '1624', '2532', '2778'].indexOf(String(deviceHeight)) >= 0) {
        return true;
    }
}

var env = /*#__PURE__*/Object.freeze({
    __proto__: null,
    appName: appName,
    getAliAppName: getAliAppName,
    getUA: getUA,
    is1688: is1688,
    isAh: isAh,
    isAk: isAk,
    isAliMiniApp: isAliMiniApp,
    isAliYun: isAliYun,
    isAliwork: isAliwork,
    isAndroid: isAndroid,
    isAp: isAp,
    isAwf: isAwf,
    isBk: isBk,
    isByteDanceMicroApp: isByteDanceMicroApp,
    isCn: isCn,
    isCunpartner: isCunpartner,
    isDingTalk: isDingTalk,
    isDingTalkMiniApp: isDingTalkMiniApp,
    isDingTalkPC: isDingTalkPC,
    isDingtalk: isDingtalk,
    isElmc: isElmc,
    isEt: isEt,
    isFliggy: isFliggy,
    isFm: isFm,
    isIOS: isIOS,
    isIhome: isIhome,
    isIphoneXSeries: isIphoneXSeries,
    isKb: isKb,
    isLt: isLt,
    isLx: isLx,
    isMicrosupply: isMicrosupply,
    isMini: isMini,
    isMiniAli: isMiniAli,
    isMiniAp: isMiniAp,
    isMiniDingTalk: isMiniDingTalk,
    isMiniFm: isMiniFm,
    isMiniLx: isMiniLx,
    isMiniTb: isMiniTb,
    isMiniTm: isMiniTm,
    isMiniTt: isMiniTt,
    isMiniWx: isMiniWx,
    isMiniweb: isMiniweb,
    isMro: isMro,
    isNebula: isNebula,
    isNj: isNj,
    isQn: isQn,
    isQuickApp: isQuickApp,
    isRetail: isRetail,
    isRetailtrader: isRetailtrader,
    isTb: isTb,
    isTm: isTm,
    isTphome: isTphome,
    isWdkhema: isWdkhema,
    isWeChatMiniProgram: isWeChatMiniProgram,
    isWeb: isWeb,
    isWebAfw: isWebAfw,
    isWebAh: isWebAh,
    isWebAk: isWebAk,
    isWebAlipm: isWebAlipm,
    isWebAliwork: isWebAliwork,
    isWebAliyun: isWebAliyun,
    isWebAp: isWebAp,
    isWebAt: isWebAt,
    isWebBk: isWebBk,
    isWebCn: isWebCn,
    isWebCunpartner: isWebCunpartner,
    isWebDingTalk: isWebDingTalk,
    isWebDingTalkPC: isWebDingTalkPC,
    isWebElmc: isWebElmc,
    isWebEt: isWebEt,
    isWebFm: isWebFm,
    isWebIhome: isWebIhome,
    isWebKb: isWebKb,
    isWebLt: isWebLt,
    isWebLx: isWebLx,
    isWebNj: isWebNj,
    isWebQn: isWebQn,
    isWebRetail: isWebRetail,
    isWebRetailtrader: isWebRetailtrader,
    isWebTb: isWebTb,
    isWebTm: isWebTm,
    isWebTphome: isWebTphome,
    isWebWdkhema: isWebWdkhema,
    isWebXionganapp: isWebXionganapp,
    isWebXm: isWebXm,
    isWebYouku: isWebYouku,
    isWeex: isWeex,
    isWindvane: isWindvane,
    isXiongan: isXiongan
});

export { isWebAliyun as $, isCunpartner as A, isWdkhema as B, isAh as C, isMro as D, isMicrosupply as E, getAliAppName as F, appName as G, getUA as H, isAndroid as I, isIOS as J, isWeb as K, isWindvane as L, isFliggy as M, isDingTalk as N, isDingTalkPC as O, isWeex as P, isQuickApp as Q, isMiniDingTalk as R, isMiniAli as S, isMiniTt as T, isMiniWx as U, isMiniAp as V, isMiniTb as W, isMiniTm as X, isMiniFm as Y, isMiniLx as Z, isWebTm as _, isWebCn as a, isWebFm as a0, isWebRetail as a1, isWebXionganapp as a2, isWebAfw as a3, isWebKb as a4, isWebRetailtrader as a5, isWebXm as a6, isWebAk as a7, isWebAt as a8, isWebLt as a9, isWebNj as aa, isWebElmc as ab, isWebIhome as ac, isWebTphome as ad, isWebAliwork as ae, isWebBk as af, isWebEt as ag, isWebLx as ah, isWebQn as ai, isWebYouku as aj, isWebWdkhema as ak, isWebCunpartner as al, isWebDingTalk as am, isWebAh as an, isWebAlipm as ao, isWebDingTalkPC as ap, isMini as aq, isMiniweb as ar, env as as, isWebTb as b, isNebula as c, isTm as d, isTb as e, isAp as f, isCn as g, isAliYun as h, isWebAp as i, isFm as j, isRetail as k, isRetailtrader as l, isXiongan as m, isAwf as n, isKb as o, isAk as p, isLt as q, isNj as r, isElmc as s, isIhome as t, isTphome as u, isAliwork as v, isEt as w, isBk as x, isLx as y, isQn as z };
